import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.validateInput()
  }

  validateInput() {
    const input = this.inputTarget
    const submit = this.submitTarget
    const isValid = input.value.length === 8

    submit.disabled = !isValid
  }
} 